package org.christophertwo.cotizador.core.common

enum class SizeContent(
    val width: Int
) {
    MAX(700),
    MIN(280),
}